export const SEARCH_SUGGESTIONS_REQUEST =
  "API/ENTITIES/SEARCH_SUGGESTIONS_REQUEST";
export const SEARCH_SUGGESTIONS_REQUEST_FAILURE =
  "API/ENTITIES/SEARCH_SUGGESTIONS_REQUEST_FAILURE";
export const SEARCH_SUGGESTIONS_REQUEST_SUCCESS =
  "API/ENTITIES/SEARCH_SUGGESTIONS_REQUEST_SUCCESS";
